/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useRef, useState } from 'react';

const CreateLeadCapturePopupConfirmationQRCode = (props: any) => {
   const {
    url
  } = props;
  const svgRef = useRef<any>(null);
  const [imageUrl, setImageUrl] = useState<any>(url);

  return (
    <div className="create-lead-capture-popup-confirmation-qr-code">
        <div className="create-lead-capture-popup-confirmation-qr-code-box">
        <div className="create-lead-capture-popup-confirmation-qr-code-box-img">
            <img
                src={imageUrl}
                alt="AFP Horizon Logo"
                ref={svgRef}
            />
        </div>
      </div>
    </div>
  );
};
export default CreateLeadCapturePopupConfirmationQRCode;
